import React from 'react';
import PropTypes from 'prop-types';
import { isValidArray } from '../../../utilities/validations';

const SDImageDetail = ({ description, image, name, tiles, url }) => {
	const significantLinks = isValidArray(tiles.tile)
		? tiles.tile.map((tile) => `"${process.env.GATSBY_SITE_URL + tile.static_url}"`) : [];

		// Remove HTML tags and newlines from description
		const fixedDescription = description
			?.replace(/<a\b[^>]*>(.*?)<\/a>/gi, '')
			.replace(/<\/?[^>]+(>|$)/g, '')
			.replace(/"/g, "'")
			.replace(/(\r\n|\n|\r)/gm, ' ');

	return (
		<script
			type='application/ld+json'
			dangerouslySetInnerHTML={{
				__html: `{
				"@context": "https://schema.org",
				"@type": "WebPage",
				"name": "${name}",
				"description": "${fixedDescription}",
				"significantLink": [
					${significantLinks.join(',')}
				],
				"mainEntity": {
					"@type": "CreativeWork",
					"image": {
						"@type": "ImageObject",
						"url": "${image.image.url}",
						"caption": "${image.image_alt}"
						},
					"isPartOf": {
						"@type": "WebPage",
						"url": "${process.env.GATSBY_SITE_URL + url}"
					}
				},
				"publisher": {
					"@type": "Organization",
					"name": "Pella",
					"url:": "${process.env.GATSBY_SITE_URL}",
					"logo": {
						"@type": "ImageObject",
						"url": "https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/blta3261a1e0aec11a9/5e971d3049d4fa359510191e/pella-logo-black-spot.png"
					}
				}
			}`,
			}}
		/>
	);
};

SDImageDetail.propTypes = {
	description: PropTypes.string,
	image: PropTypes.object,
	links: PropTypes.object,
	name: PropTypes.string,
	tiles: PropTypes.object,
	url: PropTypes.string
};

export default SDImageDetail;